<template>
  <div class="part-three">
    <div class="title">
      <div style="font-size: 40px; color:#091221; font-weight: bold">
        赋能企业数字化转型技术产品
      </div>
      <div class="second-title">
        为企业提供全场景数字化软件工具
      </div>
    </div>
    <div class="part-three-main">
      <div class="part-three-main-item" @click="tab(0)">
        <img :src="require('../assets/image_1/389.png')" />
        <div :class="index==0?'active':'no-active'">智慧商城系统</div>
      </div>
      <div class="part-three-main-item" @click="tab(1)">
        <img :src="require('../assets/image_1/388.png')" />
        <div :class="index==1?'active':'no-active'">供应链中台系统</div>
      </div>
      <div class="part-three-main-item" @click="tab(2)">
        <img :src="require('../assets/image_1/387.png')" />
        <div :class="index==2?'active':'no-active'">数据通系统</div>
      </div>
    </div>
    <div class="line">
      <div v-if="left" class="line-tab" :style="{ 'left': left + 'px' }"></div>
    </div>
    <div class="flex-center mt-60">
      <img v-if="index == 0" :src="require('../assets/image_1/269.png')" />
      <img v-else-if="index == 1" :src="require('../assets/image_1/276.png')" />
      <img v-else :src="require('../assets/image_1/277.png')" />
    </div>
    <div class="tips-1" :class="{ 'mt-60': index !== 0 }">
      <template v-if="index == 0">为企业搭建全渠道线上商城平台·实现用户营销闭环和业绩持续增长</template>
      <template v-else-if="index == 1">为企业整合上下游多环节商业资源·实现供需智能匹配和全流程管控</template>
      <template v-else>为企业打通多渠道数据壁垒·实现数字化能力分发和盈利增长</template>
    </div>
    <div class="group-button">
      <div class="button-left" @click="show = true">立即咨询</div>
      <div class="button-right" @click="toUrl">查看方案</div>
    </div>
    <!-- <div class="list">
      <div class="list-item" v-for="(item, index) in list" :key="index">
        <img :src="item.img" alt="">
        <div class="list-item-title">{{ item.title }}</div>
        <div class="list-item-des">{{ item.des }}</div>
      </div>
    </div> -->

    <div class="popup" v-if="show" @click="show=false">
      <div style="position: relative;">
        <img :src="require('../assets/image_1/275.png')" style="width: 400px;" />
        <div class="popup-box">
          <div class="popup-box-title">我是您的专属商业顾问</div>
          <div class="popup-box-des">提供商业模式梳理+行业增长方案</div>
        </div>
        <div class="popup-button">扫码添加</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      list: [
        {
          img: require('../assets/part-three-logo1.png'),
          title: 'B2C商城',
          des: '搭建独立平台，提高销售利润'
        },
        {
          img: require('../assets/part-three-logo2.png'),
          title: 'B2B2C商城',
          des: '提高市场覆盖，独立后台管理'
        },
        {
          img: require('../assets/part-three-logo3.png'),
          title: 'S2B2C商城',
          des: '降低招商成本，提高平台背书'
        },
        {
          img: require('../assets/part-three-logo4.png'),
          title: '单门店线上商城',
          des: '提高老客户复购，覆盖更多潜在客户'
        },
        {
          img: require('../assets/part-three-logo5.png'),
          title: 'O2O多商家商城',
          des: '扩大服务类目，线上线下无缝衔接'
        },
        {
          img: require('../assets/part-three-logo6.png'),
          title: '连锁门店商城',
          des: '统一平台经营，提高门店数字化经营'
        },
        {
          img: require('../assets/part-three-logo7.png'),
          title: 'CPS联盟商城',
          des: '整合多平台推广资源'
        },
        {
          img: require('../assets/part-three-logo8.png'),
          title: '知识付费商城',
          des: '集中提供各类知识付费产品和服务'
        },
        {
          img: require('../assets/part-three-logo9.png'),
          title: '线上咨询商城',
          des: '随时随地互联网咨询服务'
        },
        {
          img: require('../assets/part-three-logo10.png'),
          title: '社区自提商城',
          des: '线上拼团下单，就近自提点提货'
        },
        {
          img: require('../assets/part-three-logo11.png'),
          title: '加权分润',
          des: '分润商城营业额，多劳多得'
        },
        {
          img: require('../assets/part-three-logo12.png'),
          title: '业绩奖励',
          des: '设置关系链团队业绩指标'
        },
        {
          img: require('../assets/part-three-logo13.png'),
          title: '周度考核',
          des: '周期考核达标奖励'
        },
        {
          img: require('../assets/part-three-logo14.png'),
          title: '推N返N',
          des: '奖励会员第N层分润'
        },
        {
          img: require('../assets/part-three-logo15.png'),
          title: '链动新店商',
          des: '矩阵化销售渠道'
        },
      ],
      element_style: [90, 555, 1030],
      left: 0,
      index: 0,
    };
  },

  methods: {
    tab(index = 0) {
      this.index = index;;
      this.left = this.element_style[index];
    },
    toUrl(){
      if(this.index==0){
        this.$router.push({
          path: '/product'
        })
        // window.open('https://www.yunzmall.com/dist/#/product')
      }else if(this.index==1){
        this.$router.push({
          path: '/middleground'
        })
        // window.open('https://www.yunzmall.com/dist/#/middleground')
      }else {
        this.$router.push({
          path: '/communication'
        })
        // window.open('https://www.yunzmall.com/dist/#/communication')
      }
    }
  },

  components: {},
  mounted() {
    // const htmlCollection = document.getElementsByClassName('part-three-main-item');
    // const array = Array.from(htmlCollection);

    // array.forEach(item => {
    //   console.log(item);
    //   this.element_style.push(item.offsetLeft);
    // });
    this.tab();
    this.show = false;
    // console.log(this.element_style,'s;sasas;sa;as;as;');
  },
};

</script>
<style scoped lang="scss">
.part-three {
  margin: 0 auto;
  width: 1200px;

  .popup-button {
    position: absolute;
    bottom: 35px;
    width: 160px;
    left: 100px;
    height: 49px;
    line-height: 49px;
    box-sizing: border-box;
    text-align: center;
    background: #091221;
    border-radius: 25px 25px 25px 25px;
    font-weight: 500;
    font-size: 24px;
    color: #FFFFFF;
  }

  .popup-box-des {
    font-weight: 400;
    font-size: 20px;
    color: #404040;
    line-height: 1;
  }

  .popup-box-title {
    font-weight: bold;
    font-size: 24px;
    color: #091221;
    line-height: 1;
    margin-bottom: 10px;
  }

  .popup-box {
    position: absolute;
    top: 190px;
    left: 30px;
    text-align: center;
  }

  .popup {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.7);
  }

  .mt-60 {
    margin-top: 60px;
  }

  .group-button {
    margin: 40px auto 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .button-right {
    width: 160px;
    margin-left: 15px;
    height: 49px;
    line-height: 49px;
    background: linear-gradient( 90deg, #0E63FF 0%, #007EFF 100%);
    border-radius: 25px 25px 25px 25px;
    font-weight: 500;
    text-align: center;
    font-size: 24px;
    cursor: pointer;
    color: #FFFFFF;
  }

  .button-left {
    cursor: pointer;
    width: 160px;
    height: 49px;
    margin-right: 15px;
    line-height: 49px;
    background: #091221;
    border-radius: 25px 25px 25px 25px;
    font-weight: 500;
    font-size: 24px;
    color: #FFFFFF;
    text-align: center;
  }

  .tips-1 {
    font-weight: 400;
    font-size: 24px;
    color: #404040;
    text-align: center;
  }

  .line {
    width: 1200px;
    height: 1px;
    margin: 25px auto 0;
    position: relative;

    &::after {
      content: "";
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background-color: #404040;
      opacity: 0.5;
    }

  }

  .line-tab {
    position: absolute;
    width: 69px;
    height: 9px;
    margin-top: -4.5px;
    background: linear-gradient( 90deg, #0E63FF 0%, #007EFF 100%);
    border-radius: 30px 30px 30px 30px;
  }

  .flex-center {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .mt-60 {
    margin-top: 60px;
  }

  .part-three-main {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .part-three-main-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
  }
  .active{
    font-weight: bold;
    font-size: 24px;
    color: #007EFF;
  }
  .no-active{
    font-weight: 500;
    font-size: 24px;
    color: #000000;
  }

  .second-title {
    font-size: 24px;
    color: #404040;
    margin-top: 30px;
    font-weight: 400;
    margin-bottom: 60px;
  }

  .part-three {
    margin-top: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-color: #fff;
    padding-bottom: 100px;
    padding-left: 24rem;
    padding-right: 24rem;
  }

  .title {
    margin-top: 100px;
  }

  .list {
    margin-top: 80px;
    width: 1200px;
    display: grid;
    grid-template-columns: repeat(5, 1fr);
  }

  .list-item {
    padding: 1.25rem 0;
    background-color: #ffffff;
    border-radius: 10px;
    text-align: center;
    margin-right: 2rem;
    margin-bottom: 2.17rem;
  }

  .list-item:nth-child(5n) {
    margin-right: 0px;
  }

  .list-item:hover {
    box-shadow: 0px 13px 20px 1px rgba(117, 139, 185, 0.2);
  }

  .list-item-title {
    color: #000000;
    font-size: 20px;
    font-weight: bold;
    margin-top: 10px;
  }

  .list-item-des {
    color: rgba(0, 0, 0, 0.7);
    font-size: 12px;
    margin-top: 5px;
  }
}
</style>